import TeenGuardianWorkspace from "../../../components/teen/guardian/TeenGuardianWorkspace";

const TeenGuardiansPage = () => {
  return <TeenGuardianWorkspace />;
};

export default TeenGuardiansPage;
